import { Observable, throwError } from 'rxjs';
import { ElementRef, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { EmbedConfig } from './../../models/analytics/embed-config';
import { MenuItemModel } from './../../models/analytics/menu-item-model';
import { PowerBIReport } from './../../models/analytics/power-bi-report';
import { ItemIdModel } from 'src/app/core/models/filter-model/item-id-model';
import { trendingTopicInput, trendingTopicOutput, trendingTopicsList } from '../../models/view-model/trending-topics.model';
import { catchError, retry } from 'rxjs/operators';

//@Injectable({ providedIn: 'root' })
@Injectable({ providedIn: 'root' })
export class AnalyticsService {

  constructor(private http: HttpClient) {
  }
  getPowerBIReport(reportId: number): Observable<EmbedConfig> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', reportId.toString());
    return this.http.get<EmbedConfig>(`${environment.config.baseAppURL}/Analytics/GetPowerBIReport`, { headers });
  }

  getReportDetails(reportId: number): Observable<PowerBIReport> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<PowerBIReport>(`${environment.config.baseAppURL}/Analytics/GetReportById?id=` + reportId, { headers });
  }

  isGlobalLibraryOn(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<any>(`${environment.config.baseAppURL}/UserManagement/IsGlobalLibraryOn`, { headers });
  }

  getUserRole(userId: string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<any>(`${environment.config.baseAppURL}/UserManagement/GetUserRole`, { headers });
  }

  getLibraryMenu(): Observable<MenuItemModel[]> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<MenuItemModel[]>(`${environment.config.baseAppURL}/UserManagement/GetMenuItems`, { headers });
  }

  

  getLibraryRulebook(): Observable<ItemIdModel[]> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // return this.http
    // .get<ItemIdModel[]>(`${environment.config.baseAppURL}/UserManagement/GetLibraryRulebooks`, { headers })
    // ;
    return this.http.get<ItemIdModel[]>(`${environment.config.baseAppURL}/UserManagement/GetLibraryRulebooks`, { headers })
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }
  GetTrendingTopics(topicInput: trendingTopicInput): Observable<trendingTopicOutput> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(topicInput));;
    return this.http.get<trendingTopicOutput>(`${environment.config.baseAppURL}/Analytics/GetTrendingTopics`, { headers });
  }
  // error handler
  private handleError(error: HttpErrorResponse) {
    // return an ErrorObservable with a user-facing error message
    return throwError(error.error?.error);
  }
}
